import { baseImageUrl, platform } from '../constants'

const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

export const getStepThreeMobileImagePath = (
  browser: string,
  os: string,
): string => {
  const imagePaths: { [key: string]: string } = {
    'mobile-Iphone-Chrome': `${baseImageUrl}/browsers_step_three_mobile/mobile-ios-chrome.png`,
    'mobile-Iphone-Safari': `${baseImageUrl}/browsers_step_three_mobile/mobile-ios-safari.png`,
    'mobile-Android-Firefox': `${baseImageUrl}/browsers_step_three_mobile/mobile-android-firefox.png`,
    'mobile-Android-Edge': `${baseImageUrl}/browsers_step_three_mobile/mobile-android-edge.png`,
    'mobile-Android-Samsung': `${baseImageUrl}/browsers_step_three_mobile/mobile-android-samsung.png`,
  }

  const key = `${platform}-${capitalize(os)}-${capitalize(browser)}`

  return (
    imagePaths[key] ||
    'No se encontro la imagen para este dispositivo o browser'
  )
}
